export default theme => ({
  stat: {
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'center',
  },
  title: {
    fontSize: 18,
    color: theme.palette.text.meta,
  },
  value: {
    fontWeight: 'bold',
    fontSize: 18,
    color: theme.palette.text.bold,
  },
});
